import { render, staticRenderFns } from "./LensFlare.vue?vue&type=template&id=3c84087d&"
import script from "./LensFlare.vue?vue&type=script&lang=js&"
export * from "./LensFlare.vue?vue&type=script&lang=js&"
import style0 from "./LensFlare.vue?vue&type=style&index=0&id=3c84087d&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports